var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable, override } from 'mobx';
import { deserialize } from '../../../../utils/serializr/serializr';
import { MedFile } from '../medFile/MedFile';
import { ImageCategory } from '../../../learnware/LearnwareEnums';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { editable } from '../../../../utils/mobx/decorators/editable';
import { ImgLegacy } from './modules/ImgLegacy';
import { runtime } from '../../../runtime/Runtime';
import { sleep } from '../../../../utils/helper/helper_time';
export class Img extends MedFile {
    type = 'img';
    /** The original width of the image in pixel. */
    naturalWidth_pixel = 100;
    /** The original height of the image in pixel. */
    naturalHeight_pixel = 100;
    /** Kind of image (e.g. clipart oder photo). */
    imageCategory = ImageCategory.NotClassified; // clipart oder photo
    svgSourceFileUrl = '';
    svgUrl = '';
    svgFileSize = 0;
    legacyId;
    legacyFileSize = 0;
    legacyFilePath = '';
    legacyFileExtension = '';
    legacyQuestionId = 0;
    tempBase64 = '';
    defaultImgPath = '/data2/img/1/default.png';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get isSvgrComponent() {
        return this.fileExtension === 'svg' && !!this.entityStore.flexMap.get('isSvgComponent');
    }
    set isSvgrComponent(b) {
        this.entityStore.flexMap.set('isSvgComponent', b);
    }
    get src() {
        if (this.tempBase64 && this.tempBase64.length > 0)
            return this.tempBase64;
        if (this.base64.length > 0) {
            this.scheduleForUpload();
            return this.base64;
        }
        if (!this.naturalWidth_pixel && runtime.isBrowserRuntime && runtime.runtimePermissions.hasEditFunctionality) {
            setTimeout(this.detectImgDimensions, 100);
        }
        if (this.legacyFilePath.length > 0 && this.legacyFileSize > 0) {
            return this.context.app.appHost.dataHref + this.legacyFilePath;
        }
        if (this.filePath.length > 0) {
            return this.medFileInfo.nativeUrl;
        }
        return this.context.app.appHost.data2Href + this.defaultImgPath;
    }
    get srcWithoutHost() {
        const x = this.src.split('.schlaukopf.de');
        return x.length > 1 ? x[1] : x[0];
    }
    get isDummy() {
        return this.src.includes(this.defaultImgPath);
    }
    get imgLegacy() {
        return new ImgLegacy(this);
    }
    detectImgDimensions() {
        if (typeof window === 'undefined')
            return;
        const i = document.createElement('img');
        i.addEventListener('load', action(e => {
            if (i.naturalWidth > 0) {
                this.naturalWidth_pixel = i.naturalWidth;
                this.naturalHeight_pixel = i.naturalHeight;
            }
        }), false);
        i.src = this.src;
    }
    static fromSerialized(json = {}) {
        return deserialize(Img, json);
    }
    get mobileFileSize() {
        if (this.parent.key === 'backgroundImage') {
            return this.fileSize;
        }
        return 0;
    }
    set mobileFileSize(s) { }
    static get serializeInfo() {
        return {
            extends: MedFile.serializeInfo,
            props: {
                legacyId: true,
                legacyFileSize: true,
                legacyFilePath: true,
                legacyFileExtension: true,
                legacyQuestionId: true,
                base64_svg: true,
                naturalWidth_pixel: true,
                naturalHeight_pixel: true,
                imageCategory: true,
                //  mobileFileSize: true
            },
            afterDeserialize: async ({ target, context }) => {
                if (!runtime.browserRuntime)
                    return;
                if (runtime.runtimePermissions.hasEditFunctionality && ['question', 'bundle'].includes(context.rootContext.target.type)) {
                    context.rootContext.target.measuredAssetSize += 0; // Math.ceil(target.mobileFileSize / 1000)
                }
                if (runtime.browserRuntime.app.appBoot.timeSinceStartup < 8000) {
                    await sleep(5000);
                }
                const img = target;
                if (img.parent.key === 'backgroundImage') {
                    runtime.browserRuntime.browserPreload.preloadImage(img.src);
                }
            },
        };
    }
}
__decorate([
    editable()
], Img.prototype, "naturalWidth_pixel", void 0);
__decorate([
    editable()
], Img.prototype, "naturalHeight_pixel", void 0);
__decorate([
    editable()
], Img.prototype, "imageCategory", void 0);
__decorate([
    editable()
], Img.prototype, "svgSourceFileUrl", void 0);
__decorate([
    editable()
], Img.prototype, "svgUrl", void 0);
__decorate([
    editable()
], Img.prototype, "svgFileSize", void 0);
__decorate([
    editable()
], Img.prototype, "legacyId", void 0);
__decorate([
    editable()
], Img.prototype, "legacyFileSize", void 0);
__decorate([
    editable()
], Img.prototype, "legacyFilePath", void 0);
__decorate([
    editable()
], Img.prototype, "legacyFileExtension", void 0);
__decorate([
    editable()
], Img.prototype, "legacyQuestionId", void 0);
__decorate([
    editable()
], Img.prototype, "tempBase64", void 0);
__decorate([
    computed
], Img.prototype, "isSvgrComponent", null);
__decorate([
    override
], Img.prototype, "src", null);
__decorate([
    computed
], Img.prototype, "isDummy", null);
__decorate([
    memoize
], Img.prototype, "imgLegacy", null);
__decorate([
    action.bound
], Img.prototype, "detectImgDimensions", null);
__decorate([
    memoize
], Img, "serializeInfo", null);
